import Config from "../../config/Config";

export default class WhatsNewAreaUtils {
    static getDownloadText() {
        return addOsLinks(Config.messages.headerDownload);
    }

    static getDownloadTextMobile() {
        return addOsLinks(Config.messages.downloadMobile);
    }
}

function addOsLinks(message) {
    return message
        .replace("__SET_HREF_WINDOWS__", Config.resources.DOWNLOAD.windows)
        .replace("__SET_HREF_MAC__", Config.resources.DOWNLOAD.mac)
        .replace("__SET_HREF_IOS__", Config.resources.DOWNLOAD.ios)
        .replace("__SET_HREF_ANDROID__", Config.resources.DOWNLOAD.android);
}
